import { useMutation } from "@tanstack/react-query";
import Spinner from "Components/CommonComponents/Spinner";
import { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import { FiPlus } from "react-icons/fi"; // Import plus icon
import { deleteImage } from "services/stockService";

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    width: "700px",
    position: "relative",
  },
  title: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "15px",
    color: "#333",
  },
  previewGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: "10px",
    marginBottom: "15px",
  },
  imageContainer: {
    position: "relative",
    width: "220px",
    height: "220px",
    borderRadius: "10px",
    overflow: "hidden",
    border: "2px solid #ddd",
  },
  previewImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  removeButton: {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "red",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    cursor: "pointer",
    fontSize: "14px",
  },
  fileInputWrapper: {
    width: "220px",
    height: "220px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "2px dashed #ddd",
    borderRadius: "10px",
    cursor: "pointer",
    position: "relative",
    backgroundColor: "#f9f9f9",
  },
  fileInput: {
    position: "absolute",
    width: "100%",
    height: "100%",
    opacity: 0,
    cursor: "pointer",
  },
  plusIcon: {
    fontSize: "30px",
    color: "#888",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "15px",
  },
  cancelButton: {
    backgroundColor: "#ccc",
    color: "#333",
    border: "none",
    padding: "8px 15px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  saveButton: {
    backgroundColor: "#0077D4",
    color: "white",
    border: "none",
    padding: "8px 15px",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

const StockImageUpload = ({
  isOpen,
  onClose,
  onSave,
  defaulImages = [],
  isEdit,
  ClientCode,
  ItemCode,
}) => {
  const {
    data: deletedImage,
    isError: deleteImageIsError,
    isPending: deleteImageIsLoading,
    isSuccess: deleteImageIsSuccess,
    mutate: MutateDeleteImage,
  } = useMutation({ mutationFn: deleteImage });

  const [images, setImages] = useState(defaulImages);
  const [ImageToDelete, setImageToDelete] = useState("");


  useEffect(()=>{
     const filtered = images?.filter((item)=>{
      if(JSON.stringify(item) != ImageToDelete){
        return item
      }
     })
     setImages(filtered)
     console.log(deleteImageIsSuccess)
  },[deleteImageIsSuccess])

  // Handle Image Selection
  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setImages((prevImages) => [...prevImages, ...newImages]);
    event.target.value = "";
  };

  // Handle Remove Image
  const handleRemoveImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  // Handle Save
  const handleSave = () => {
    onSave(images);
    onClose();
  };


  return isOpen ? (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {deleteImageIsLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: "9999",
              width: "100%",
              height: "100%",
              background: "white",
              opacity: "0.5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spinner />
          </div>
        )}

        <h2 style={styles.title}>Upload Images</h2>

        {/* Image Preview Grid */}
        <div style={styles.previewGrid}>
          {images.map((img, index) => (
            <div key={index} style={styles.imageContainer}>
              <img
                src={img.preview}
                alt={`preview-${index}`}
                style={styles.previewImage}
              />
              <button
                onClick={() => {
                  if (img?.file == null) {
                    const extractedPath = img?.preview?.replace(
                      "https://rrgold.loyalstring.co.in/",
                      ""
                    );
                    const formData = new FormData();
                    formData.append("ClientCode", ClientCode);
                    formData.append("ItemCode", ItemCode);
                    formData.append("ImagePath", extractedPath);
                   
                    setImageToDelete(JSON.stringify(img))
                    MutateDeleteImage({
                      payload: formData,
                    });
                  } else {
                    handleRemoveImage(index);
                  }
                }}
                style={styles.removeButton}
              >
                x
              </button>
            </div>
          ))}

          {/* File Input (Visible only if less than 5 images are uploaded) */}
          {images?.length < 5 && (
            <label style={styles.fileInputWrapper}>
              <FiPlus style={styles.plusIcon} />
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleImageChange}
                style={styles.fileInput}
              />
            </label>
          )}
        </div>

        {/* Buttons */}
        <div style={styles.buttonContainer}>
          <button onClick={onClose} style={styles.cancelButton} type="button">
            Cancel
          </button>
          <button onClick={handleSave} style={styles.saveButton} type="button">
            Save
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default StockImageUpload;
